import {Component} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import CreateFreelance from './Components/CreateFreelance/CreateFreelance.jsx'
import mustBeLogged from '../../components/Must/MustBeLogged.jsx'
import mustHaveAcceptedCGU from '../../components/Must/MustHaveAcceptedCGU.jsx'
import StrategyFreelanceContainer from './StrategyFreelanceContainer.jsx'
import withCurrentUniverse, {CURRENT_USER_PRIORITY} from '../../HOC/withCurrentUniverse.jsx'

import actions from '../../components/CurrentUserLoader/actions.js'
import conf from '../../../shared/conf.js'
import {getLastStepDone} from '../../services/stepService.js'

class CreateFreelanceContainer extends Component {
  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return nextProps.endLoadingCurrentUser
  }

  render() {
    const {currentUser, currentFreelance, endLoadingCurrentUser} = this.props
    const currentStep = getLastStepDone(currentUser, currentFreelance)

    if (!endLoadingCurrentUser) {
      return null
    }

    return <StrategyFreelanceContainer
      {...this.props}
      currentStep={currentStep}
      currentUser={currentUser}
      loading={!endLoadingCurrentUser}
      profile={{user: currentUser, freelance: currentFreelance}}
      view={CreateFreelance}
    />
  }
}

export default connect(
  (state) => ({
    endLoadingCurrentUser: state.currentUser.endLoading,
  }),
  (dispatch) => bindActionCreators(actions, dispatch)
)(
  withCurrentUniverse(
    mustBeLogged(
      mustHaveAcceptedCGU(CreateFreelanceContainer),
      conf.accountTypes.freelance
    ),
    CURRENT_USER_PRIORITY
  )
)